import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'app/utils/appconfig/app-config.service';
import { Observable } from 'rxjs';
import { NavigationService } from '../navigation/navigation.service';
import { ILoginResponse } from './models/loginResponse';

@Injectable()
export class MitIdService {
    private apiUrl: string;
    private localStorageSuccessRedirectKey = 'successRedirectMitIdPage';
    private localStorageFailRedirectKey = 'failRedirectMitIdPage';

    constructor(public http: HttpClient, private config: AppConfigService, private navigationService: NavigationService) {
        this.apiUrl = this.config.appConfig.apiHost;
    }

    private saveSuccessRedirectUrl(redirectUrl: string) {
        const encoded = redirectUrl ? this.safeUrlEncode(redirectUrl) : '';

        sessionStorage.setItem(this.localStorageSuccessRedirectKey, encoded);
    }

    private saveFailRedirectUrl(redirectUrl: string) {
        const encoded = redirectUrl ? this.safeUrlEncode(redirectUrl) : '';

        sessionStorage.setItem(this.localStorageFailRedirectKey, encoded);
    }

    private safeUrlEncode(url: string): string {
        // encode url parameters or they will be removed
        const urlSplit = url.split('?');

        // filter out MitId parameters (state and code)
        const parameters =
            urlSplit.length === 1
                ? ''
                : urlSplit[1]
                      .split('&')
                      .filter((p) => p.indexOf('state') === -1 && p.indexOf('code') === -1)
                      .join('&');
        const encodedUri = urlSplit.length === 1 ? urlSplit[0] : `${urlSplit[0]}?${encodeURIComponent(parameters)}`;

        return encodedUri;
    }

    getSuccessRedirectUrl(): string {
        const redirect = sessionStorage.getItem(this.localStorageSuccessRedirectKey);

        return !redirect ? null : decodeURIComponent(redirect);
    }

    getFailRedirectUrl(): string {
        const redirect = sessionStorage.getItem(this.localStorageFailRedirectKey);

        return !redirect ? null : decodeURIComponent(redirect);
    }

    clearRedirectUrls() {
        sessionStorage.removeItem(this.localStorageSuccessRedirectKey);
        sessionStorage.removeItem(this.localStorageFailRedirectKey);
    }

    login(successRedirectUrl: string, failRedirectUrl: string, requireSsn: boolean = false): Observable<ILoginResponse> {
        this.saveSuccessRedirectUrl(successRedirectUrl);
        this.saveFailRedirectUrl(failRedirectUrl);

        const mitIdLandingPage = window.location.origin + this.navigationService.getUrl('mitid-landing');

        const url = `${this.apiUrl}/user-identity/login?redirectUri=${mitIdLandingPage}&requireSsn=${requireSsn}&api-version=2.0`;
        return this.http.get<ILoginResponse>(url);
    }
}
